import RestService from "./rest.service";

class competencyService {
  changeRoute(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/route/change`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  reOpen(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/reopen`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getRouteListEmployees(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/route/filter`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listRoute() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/manage/route`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getFilterCycleType() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/manage/filter`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getFilter(cycle) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/form/manage/filter?type=${cycle}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListForm(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/filter`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  delete(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/delete`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  restore(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/form/manage/restore`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new competencyService();
